/* Jedno API pro pozvání do týmu (14. 10. 2026).
 * Používají ho: PozvankaPage (/pozvanka/:token), PozvatDoTymu (Nastavení, Tým,
 * /manazer), MujManazerKarta a obrazovka Tým (Odebrat z týmu).
 * Všechno jsou tenké obaly nad endpointy /api/manager/* — stav se nikdy
 * nehádá z odpovědi, volající si ho po akci načte znovu. */
import api from "@/lib/api";
import { INFORMACE_VERZE } from "./pozvankyTexty";

const enc = (v) => encodeURIComponent(String(v || ""));

/**
 * Veřejný náhled pozvánky.
 * @returns {{stav:"ok",data:object}|{stav:"nenalezena"}|{stav:"starsiServer"}|{stav:"chyba",kod?:number}}
 *  · starsiServer = 404 s výchozím detailem FastAPI „Not Found“: routa ještě
 *    neběží (backend před redeployem) — stránka pošle člověka do Nastavení.
 */
export async function nactiNahled(token) {
  try {
    const res = await api.get(`/api/manager/pozvanka/${enc(token)}`, { timeout: 15000 });
    const data = res && res.data;
    if (!data || typeof data !== "object" || typeof data.stav !== "string") return { stav: "chyba" };
    return { stav: "ok", data };
  } catch (err) {
    const r = err && err.response;
    if (r && r.status === 404) {
      const detail = String((r.data && r.data.detail) || "");
      return detail === "Not Found" || !detail ? { stav: "starsiServer" } : { stav: "nenalezena" };
    }
    return { stav: "chyba", kod: r ? r.status : undefined };
  }
}

export function prijmout(token) {
  return api.post(`/api/manager/invitations/${enc(token)}/accept`, { informace_verze: INFORMACE_VERZE });
}

export function odmitnout(token) {
  return api.post(`/api/manager/invitations/${enc(token)}/reject`);
}

/** Odejít z týmu — jen vlastní vztah, endpoint nebere žádné id. */
export function odejitZTymu() {
  return api.delete("/api/manager/my-relationship");
}

export function nactiOdchozi() {
  return api.get("/api/manager/invitations", { timeout: 12000 });
}

export function pozvat(email) {
  return api.post("/api/manager/invite-advisor", { email: String(email || "").trim().toLowerCase() });
}

export function zrusit(id) {
  return api.delete(`/api/manager/invitations/${enc(id)}`);
}

/**
 * Pozvat znovu — funguje se starým i novým backendem.
 * Prošlá pozvánka ve stavu pending drží unikátní index (zvoucí + e-mail):
 * nejdřív ji zrušíme (404 = už není pending, nevadí), pak vznikne nová.
 * Nový backend prošlou pending při POST uzavře sám (expired).
 */
export async function pozvatZnovu(inv) {
  const email = String((inv && inv.invitee_email) || "").trim().toLowerCase();
  if (!email) throw new Error("bez-emailu");
  if (inv.status === "pending" && inv.id) {
    try {
      await zrusit(inv.id);
    } catch (err) {
      if (!(err && err.response && err.response.status === 404)) throw err;
    }
  }
  return pozvat(email);
}

/** Manažer odebere člena (existující DELETE /team/{id}, jen vlastní vztah). */
export function odebratClena(advisorId) {
  return api.delete(`/api/manager/team/${enc(advisorId)}`);
}
